import TypeaheadContainer from "../../../../Components/Forms/FormsWidgets/Typeahead/Typeahead"

const Typeahead = () => {
  return (
    <div className='page-body'>
      <TypeaheadContainer />
    </div>
  )
}

export default Typeahead